
import React, { useState, useEffect } from 'react';
import '../css/Login.css';
import IslandLogo from '../assets/IslandClub.svg';
// import axios from "axios";
import { PortalContextProvider, PortalContext } from '../Contexts/PortalContext';



function Portal() {

    const baseURL = 'https://www.tevalis.com/API/CRM/1326/110/Points';

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'GUID': '0cc19410-4f65-4fb3-9c71-890deb86572c',
            'DEVID': 'LOYALCO20200713_2F8E59F7-887D-437D-B7F8-81B0E35A8B68',
            'GUID2': '5c45891f-5bb4-4032-b7ea-61bc36bd8ee5',
            'Access-Control-Allow-Origin': '*'
        }
    };

    // useEffect(() => {
    //     axios.get(baseURL, config).then((response) => {
    //         setPost(response);
    //     });

    //   }, []);

    function close() {

        window.close();
    }

    return (

        <PortalContextProvider>
            <PortalContext.Consumer>
                {context => (
                    <div className="App">
                        <img src={IslandLogo} alt='Logo' />
                        
                        <div className='Portal-Background'>
                            <p className='Portal-Heading'>Your points</p>
                            <div className="Portal-Grid">
                                <div className="Portal-Point-Value-Container">
                                    <p className="Portal-Point-Value-Text">{context.points?.balance}</p>
                                    <p className="Portal-Point-Value-Heading">Your points balance</p>
                                </div>

                                <div className="Portal-Point-Value-Container">
                                    <p className="Portal-Point-Value-Text">{context.points?.value}</p>
                                    <p className="Portal-Point-Value-Heading">Points value</p>
                                </div>

                            </div>

                            
                            <div className="Portal-Bottom">
                                <p className="Form-Bottom-Text">Something not quite right? Contact our <a href="mailto:helpdesk@theislandquarter.com">Helpdesk</a></p>
                                {/* <p className="Form-Bottom-Text">{post.toString}</p> */}
                            </div>
                        </div>

                        <button className="Form-Close-Button" onClick={()=> {
                            context.signOut();
                            close();
                        }
                            
                            }>Close</button>

                    </div>
                )}
            </PortalContext.Consumer>

        </PortalContextProvider>
    )
}


export default Portal;